
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"17.758","height":"24.419"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3.699 17.759V6.742A6.742 6.742 0 0110.44-.001h.576a6.742 6.742 0 016.741 6.742 6.742 6.742 0 01-6.741 6.741H8.843v4.276z","fill":"#ab4ef7"}}),_c('path',{attrs:{"d":"M8.844 13.483v4.275H3.7v-6.092a6.736 6.736 0 00-3.7 6.01 6.742 6.742 0 006.741 6.742h.576a6.742 6.742 0 006.741-6.743v-4.923a6.7 6.7 0 01-3.042.731z","fill":"#19c9e9"}}),_c('path',{attrs:{"d":"M8.914 6.66v4.276H6.741a6.7 6.7 0 00-3.042.731v6.093h5.144v-4.275h2.173a6.7 6.7 0 003.042-.731V6.661z","fill":"#6d3ff1"}})])
          )
        }
      }
    